function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_4892",
  "data-name": "Grupo 4892",
  transform: "translate(-935.75 -922)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_4891",
  "data-name": "Grupo 4891",
  transform: "translate(935.75 922)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3044",
  "data-name": "Grupo 3044"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3042",
  "data-name": "Grupo 3042",
  transform: "translate(2.917 2.917)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_710",
  "data-name": "Caminho 710",
  d: "M14.667,3H4.458A1.463,1.463,0,0,0,3,4.458V14.667a1.463,1.463,0,0,0,1.458,1.458H14.667a1.463,1.463,0,0,0,1.458-1.458V4.458A1.463,1.463,0,0,0,14.667,3Zm0,11.667H4.458V4.458H14.667Z",
  transform: "translate(-3 -3)",
  fill: "#003DA5"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3045",
  "data-name": "Grupo 3045",
  transform: "translate(2.187 2.917)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1792",
  "data-name": "Ret\\xE2ngulo 1792",
  width: 1.458,
  height: 7.292,
  fill: "#003DA5"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1793",
  "data-name": "Ret\\xE2ngulo 1793",
  width: 1.458,
  height: 7.292,
  transform: "translate(7.292)",
  fill: "#003DA5"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1796",
  "data-name": "Ret\\xE2ngulo 1796",
  width: 0.729,
  height: 0.729,
  transform: "translate(5.833 6.562)",
  fill: "#003DA5"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1797",
  "data-name": "Ret\\xE2ngulo 1797",
  width: 0.729,
  height: 5.833,
  transform: "translate(5.833)",
  fill: "#003DA5"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1798",
  "data-name": "Ret\\xE2ngulo 1798",
  width: 1.458,
  height: 0.729,
  transform: "translate(3.646 6.562)",
  fill: "#003DA5"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1799",
  "data-name": "Ret\\xE2ngulo 1799",
  width: 1.458,
  height: 5.833,
  transform: "translate(3.646)",
  fill: "#003DA5"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1802",
  "data-name": "Ret\\xE2ngulo 1802",
  width: 0.729,
  height: 0.729,
  transform: "translate(2.187 6.562)",
  fill: "#003DA5"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1803",
  "data-name": "Ret\\xE2ngulo 1803",
  width: 0.729,
  height: 5.833,
  transform: "translate(2.187)",
  fill: "#003DA5"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3043",
  "data-name": "Grupo 3043"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1214",
  "data-name": "Caminho 1214",
  d: "M5.187,13.208H4.458A1.463,1.463,0,0,1,3,11.75V4.458A1.463,1.463,0,0,1,4.458,3H11.75a1.463,1.463,0,0,1,1.458,1.458v.729H11.75V4.458H4.458V11.75h.729Z",
  transform: "translate(-3 -3)",
  fill: "#003DA5"
})))));

function SvgGroupedBill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 16.042 16.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupedBill);
export default __webpack_public_path__ + "static/media/groupedBill.d36211e6.svg";
export { ForwardRef as ReactComponent };